export const GENDERS = [
  { key: 'WOMAN', label: 'Mulheres', value: 'WOMAN' },
  { key: 'MAN', label: 'Homens', value: 'MAN' },
  { key: 'TRANSEX', label: 'Trans', value: 'TRANSEX' },
];
